export function arrayUnique<T, K extends string | number = string | number>(
  array: T[],
  uniqueBy: (item: T) => K,
): T[] {
  const seen = new Set<K>();
  const result: T[] = [];
  for (const item of array) {
    const key = uniqueBy(item);
    if (seen.has(key)) continue;
    seen.add(key);
    result.push(item);
  }
  return result;
}

export function arrayChunk<T>(array: T[], chunkLength: number): T[][] {
  if (chunkLength <= 0) {
    throw new Error('chunkLength must be greater than 0');
  }

  const result: T[][] = [];
  for (let i = 0; i < array.length; i += chunkLength) {
    result.push(array.slice(i, i + chunkLength));
  }
  return result;
}
